import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Services
import { ServiceBase } from '../service-base';

// Models
import { AccountEntryLine } from 'src/app/@shared/models/accounting/account-entry-line.model';

const CLASS_NAME = 'AccountEntryLine';
const ENDPOINT = `/account-entry-lines/`;

@Injectable({
    providedIn: 'root'
})
export class AccountEntryLineService extends ServiceBase {

    private _accountEntryLines$: BehaviorSubject<AccountEntryLine[]> = new BehaviorSubject<AccountEntryLine[]>([]);
    public readonly accountEntryLines$ = this._accountEntryLines$.asObservable();

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }

    public set accountEntryLines(value: AccountEntryLine[] | null | undefined) {
        let emptyArray: AccountEntryLine[] = [];
        let accountEntryLines = emptyArray.concat(value || []);
        this._accountEntryLines$.next(accountEntryLines);
    }

    public clearLines(): void {
        this.accountEntryLines = [];
    }
}
